import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../services/api";
import styled from "styled-components";

const SubtopicContainer = styled.div`
  max-width: 800px;
  margin: 2rem auto;
  padding: 0 1rem;
`;

const ContentCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const SubtopicDetail = () => {
  const { topicId, subtopicId } = useParams();
  const [subtopic, setSubtopic] = useState(null);

  useEffect(() => {
    const fetchSubtopic = async () => {
      try {
        const response = await api.get(
          `/topics/${topicId}/subtopics/${subtopicId}`
        );
        setSubtopic(response.data);
      } catch (error) {
        console.error("Error fetching subtopic:", error);
      }
    };

    fetchSubtopic();
  }, [topicId, subtopicId]);

  if (!subtopic) {
    return <div>Loading...</div>;
  }

  return (
    <SubtopicContainer>
      <h2>{subtopic.name}</h2>
      <ContentCard>
        <div dangerouslySetInnerHTML={{ __html: subtopic.content }} />
      </ContentCard>
    </SubtopicContainer>
  );
};

export default SubtopicDetail;
